export default "__VITE_ASSET__DNxcknJs__"